import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "@/types/api";
import eventClientApi from "@/api-client/event-client";
import { getQueryKey } from "@key.ai/constants";

export interface Timezone {
  value: string;
  label: string;
  offset: string;
  abbrev: string;
  altName: string;
  select: boolean;
}

export const useTimezones = () => {
  const queryKey = getQueryKey("TIMEZONES");

  const fetchTimezones = async (): Promise<Timezone[]> => {
    const response = await eventClientApi.get(`api/v1/public/geolocation`);
    const { data } = await response.json<ApiResponse<Timezone[]>>();

    // Ensure a default structure is returned in case of no data
    return data || [];
  };

  return useQuery<Timezone[], Error>({
    queryKey: [queryKey],
    queryFn: fetchTimezones
  });
};
